export default __webpack_public_path__ + "static/media/talent.e3d7d013.png";